import { Injectable } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Entity, getManager, Repository } from 'typeorm';
import { AllExitActionsResponseModel, ExitActionResponseModel } from '@gtpl/shared-models/hrms';
import { ExitActionRequest } from './dto/exit-action.request';
import { ExitActionDTO } from './dto/exit-action.dto';
import { ExitActionAdapter } from './dto/exit-action.adapter';
import { ExitAction } from './exit-action.entity';
import { exit } from 'process';
import { CommonResponse } from '@gtpl/shared-models/masters';
import appSettings from 'apps/services/config';

@Injectable()
export class ExitActionService {

    constructor(
        @InjectRepository(ExitAction)
        private repository: Repository<ExitAction>,
        private adapter: ExitActionAdapter,
        
    ){}

    async getExitAction(actionId: number): Promise<ExitAction>{
        const response = await this.repository.findOne({
            where: {exitActionId: actionId},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async createExitAction(data: ExitActionDTO, isUpdate: boolean): Promise<ExitActionResponseModel>{
        try{
            if(!isUpdate){
                const entity = await this.getExitAction(data.exitActionId);
                if(entity){
                    throw new ErrorResponse(11104, 'Exit Action already exits');
                }
            }else{
                const exitActionEntity = await this.getExitAction(data.exitActionId);
                if(exitActionEntity){
                    if(exitActionEntity.exitActionId != data.exitActionId){
                        throw new ErrorResponse(11104, 'Exit Action already exits');
                    }
                }
            }
            const convertedDto: ExitAction = await this.adapter.convertDtoToEntity(data,isUpdate);
            const savedExitAction: ExitAction = await this.repository.save(convertedDto);
            const convertedExitAction: ExitActionDTO = await this.adapter.convertEntityToDto(savedExitAction);

            if(convertedExitAction){
                const response = new ExitActionResponseModel(true, isUpdate? 11100: 11101, isUpdate? 'Exit action updated successfully': 'Exit action created successfully', convertedExitAction);
                return response;
            }else{
                throw new ErrorResponse(11106, 'Exit Action is saved but error while converting it into DTO');
            }
        }catch(error){
            throw error;
        }
    }

    // async getAllExitActions(): Promise<AllExitActionsResponseModel>{
    //     try{
    //         const exitActions: ExitActionDTO[] = [];
    //         const entities : ExitAction[] = await this.repository.find({
    //             order: {exitActionId: 'DESC'},
    //         });
    //         if(entities.length>0){
    //             entities.forEach(Entity => {
    //                 const exitAction: ExitActionDTO = this.adapter.convertEntityToDto(Entity);
    //                 exitActions.push(exitAction); 
    //             });
    //             const response = new AllExitActionsResponseModel(true, 11208, 'Exit Actions retrieved successfully', exitActions);
    //             return response;
    //         }else{
    //             throw new ErrorResponse(99998, 'No Records Found');
    //         }
    //     }catch(error){
    //         throw error;
    //     }
    // }
    // LEFT JOIN `+appSettings.masters_db + `.employee_details ed ON ed.employee_id = e.employee_id
    async getAllExitActions(): Promise<AllExitActionsResponseModel>{
        try{
            const manager = getManager()
            const query= 'SELECT exit_action_id as exitActionId,concat(em.employee_name,em.emp_last_name) as employeeName,e.employee_id as employeeId,em.employee_code as employeeCode,e.exit_date as exitDate,e.exit_reason as exitReason,e.remarks as remarks,e.is_active as isActive ,e.created_at as createdAt, e.created_user as createdUser, e.updated_at as updatedAt, e.updated_user as updatedUser, e.version_flag as versionFlage, e.approved_by as approvedBy ,  concat(ed.employee_name,ed.emp_last_name) as approvedByName from '+appSettings.hrms_db+`.exit_action e LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = e.employee_id LEFT JOIN ` + appSettings.masters_db + `.employee_details ed ON ed.employee_id = e.approved_by`

            const data = await manager.query(query);
            if(data.length > 0){
            const response = new AllExitActionsResponseModel(true, 11208, "Exit retrieved successfully", data);
            return response;
            }else{
                throw new ErrorResponse(99998,'No Record Found');
            }
           
            
        }catch(err){
            throw err
        }    

        
    }

    async getExitActionById(id: number): Promise<ExitAction>{
        const response = await this.repository.findOne({
            where: {exitActionId: id},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async activateOrDeactivateExitAction(req: ExitActionRequest): Promise<ExitActionResponseModel>{
        try{
            const exitActionExists = await this.getExitActionById(req.exitActionId);
            if(exitActionExists){
                if(req.versionFlag != exitActionExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone updatedt the current ExitAction information. Refresh and try again');
                }else{
                    const exitActionStatus = await this.repository.update(
                        {exitActionId: req.exitActionId},
                        {isActive: req.isActive, updatedUser: req.updatedUser},
                    );
                    if(exitActionExists.isActive){
                        if(exitActionStatus.affected){
                            const response: ExitActionResponseModel= new ExitActionResponseModel(true, 10115, 'Exit Action is de-activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10111, 'Exit Action is already de-activated');
                        }
                    }else{
                        if(exitActionStatus.affected){
                            const response: ExitActionResponseModel = new ExitActionResponseModel(true, 10114, 'Exit Action is activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10112, 'Exit Action is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            throw error;
        }
    }

    async getAllActiveExitActions(): Promise<AllExitActionsResponseModel>{
        try{
            const exitActions: ExitActionDTO[] = [];
            const entities: ExitAction[] = await this.repository.find({
                order: {exitActionId: 'ASC'}, where: {isActive: true},
            });
            if(entities.length>0){
                entities.forEach(Entity => {
                     
                    const exitAction: ExitActionDTO = this.adapter.convertEntityToDto(Entity);
                    exitActions.push(exitAction); 
                });
                const response = new AllExitActionsResponseModel(true, 11208, 'Exit Actions retrieved successfully', exitActions);
                return response;
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            throw error;
        }
    }
}
